export default function getDefaultState () {
  return {
    loading: false,
    errors: {},
    countryCodes: false
  }
}
